import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { studyGroupMembershipApi } from "@/lib/humhub-api/studyGroupMembership";
import { studyGroupKeys } from "@/lib/queryKeys/studyGroupKeys";

export const useStudyGroupYourMembership = (
  studyGroupId: string | number | null,
) => {
  // React Queryでユーザーのメンバーシップ情報取得
  const {
    data: membershipRole,
    isLoading,
    error: queryError,
    refetch,
  } = useQuery({
    queryKey: studyGroupKeys.yourMembership(studyGroupId),
    queryFn: () => {
      if (!studyGroupId) {
        throw new Error("Study group ID is required");
      }
      return studyGroupMembershipApi.getStudyGroupYourMembership(studyGroupId);
    },
    enabled: !!studyGroupId, // studyGroupIdがある場合のみクエリ実行
    staleTime: 2 * 60 * 1000, // メンバーシップ情報は2分間キャッシュ（変更頻度を考慮し短め）
  });

  const canManageMembers = useMemo(
    () =>
      !!(
        membershipRole &&
        (membershipRole.is_owner || membershipRole.role === "admin")
      ),
    [membershipRole],
  );
  const isOwner = !!membershipRole?.is_owner;

  return {
    membershipRole: membershipRole || null,
    canManageMembers,
    isOwner,
    isLoading,
    error: queryError ? String(queryError) : null,
    refetch: () => refetch(), // 手動リフェッチ
  };
};
